import { Injectable } from '@angular/core';
import { SearchItem } from '../api/search-item';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ConfigService {

  public countrySearchCodes: SearchItem[];

  public countrySearchCodesPromise: Promise<SearchItem[]>;

  constructor(private httpClient: HttpClient) {
    this.countrySearchCodes = [];
  }

  public retrieveCountrySearchCodes(): Promise<SearchItem[]> {
    if (!!this.countrySearchCodesPromise) {
      return this.countrySearchCodesPromise;
    }

    const url = `/patent/open/report/search/config/countries`;

    this.countrySearchCodesPromise = this.httpClient.get<SearchItem[]>(url).toPromise();

    this.countrySearchCodesPromise.then(countries => {
      this.countrySearchCodes = countries;
    });

    return this.countrySearchCodesPromise;
  }
}
